import { api } from '@/api';

export function SessionCheck() {
  api.fct.auth.query.useGetSession();

  return null;
}
